// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "campaign_recipient".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { campaignChannelValues, campaignRecipientStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "campaign_recipient" table (1:1 with a DB row, on the wire). */
export const campaignRecipientAtomSchema = z.object({
    id: z.string(),
    campaignId: z.string(),
    leadId: z.string(),
    channel: z.enum(campaignChannelValues),
    status: z.enum(campaignRecipientStatusValues),
    providerMessageId: z.string().nullable(),
    error: z.string().nullable(),
    sentAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    openedAt: z.string().datetime().nullable(),
    clickedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=campaignRecipient.js.map